var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.71,12.44H12.43V22h7.28A2.29,2.29,0,0,0,22,19.72V12.44H19.71Zm.2,7.28a.2.2,0,0,1-.2.2h-5a.2.2,0,0,1-.2-.2v-.35h0V15.06h0v-.34a.2.2,0,0,1,.2-.2h5a.2.2,0,0,1,.2.2v.34h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28,12.44H2v7.28A2.28,2.28,0,0,0,4.28,22h7.28V12.44H9.28Zm.2,6.93h0v.35a.2.2,0,0,1-.2.2h-5a.2.2,0,0,1-.2-.2V15.06h0v-.34a.2.2,0,0,1,.2-.2h5a.2.2,0,0,1,.2.2v.34h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.71,11.6H12.43V2h7.28A2.29,2.29,0,0,1,22,4.31V11.6H19.71Zm.21-7.29a.2.2,0,0,0-.21-.2h-5a.2.2,0,0,0-.2.2v.35h0V9h0v.34a.2.2,0,0,0,.2.2h5a.2.2,0,0,0,.2-.2V9h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28,11.6H2V4.31A2.29,2.29,0,0,1,4.29,2h7.28V11.6H9.28Zm.2-6.94h0V4.31a.2.2,0,0,0-.2-.2h-5a.2.2,0,0,0-.21.2V9h0v.34a.2.2,0,0,0,.2.2h5a.2.2,0,0,0,.2-.2V9h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridView);
export default __webpack_public_path__ + "static/media/grid-view.190ddc1b1dbd1f8e38df42ecac40ad05.svg";
export { ForwardRef as ReactComponent };